/* eslint-disable sort-keys, max-len */
export default {
    // bidding console
    bidding_console: {
        console: {
            button: {
                login: '응찰자로 로그인하기',
                signup: '응찰자로 가입하기',
                register_long: '응찰등록하기',
                pending: '응찰등록 승인 대기 중',
                declined: '응찰등록 거부됨',
                closed: 'Lot이 마무리되었습니다',
                sent: '응찰가가 전송되었습니다',
                outbid: '경쟁 응찰자가 상회 응찰 제시. 응찰하기 {amount}',
                bid: '응찰하기 {amount}',
                winning: '최고가를 제시한 응찰자입니다',
            },
            conversions: {
                lot_number: 'LOT {lotNumber}',
            },
            description: {
                estimate_range: '추정가 {low} - {high}',
                images_label: '{currentImageNumber} / {totalImages}',
            },
            messages: {
                competing_bid_amount: '{amount}: 현장 응찰',
                competing_bidder_outbid_by_liveauctioneers_absentee:
                    '{paddleNumber}번 응찰자가 현장 응찰자보다 높은 부재자 응찰가를 제시했습니다',
                last_bid_retracted: '마지막 응찰가 {amount} 철회되었습니다',
                liveauctioneers_bid_amount: '{amount}: LiveAuctioneers {paddleNumber}번 응찰자',
                liveauctioneers_bid_amount_absentee: '{amount}: LiveAuctioneers {paddleNumber}번 응찰자의 부재자 응찰',
                lot_number_passed: 'Lot {lotNumber} 통과합니다',
                lot_number_reopened: 'Lot {lotNumber} 다시 오픈합니다',
                lot_number_skipped: 'Lot {lotNumber} 넘어갑니다',
                lot_number_unsold: 'Lot {lotNumber} 유찰되었습니다',
                lot_opened_asking: 'Lot {lotNumber} {amount} 부터 시작합니다',
                lot_sold_competing_bidder: 'Lot {lotNumber} 현장 응찰자에게 {amount}에 낙찰되었습니다',
                lot_sold_liveauctioneers_bidder:
                    'Lot {lotNumber} 응찰자 {paddleNumber}번에게 {amount}에 낙찰되었습니다',
                my_bid_amount: '{amount}: 고객님 응찰하셨습니다',
                my_bid_amount_absentee: '{amount}: 고객님 부재자 응찰하셨습니다',
                my_bid_retracted: '고객님의 응찰가 {amount} 철회되었습니다',
                registration_approved: '응찰등록이 승인되었습니다',
                reserve_not_met: '내정가 미만입니다',
                you_been_outbid_by_liveauctioneers_absentee:
                    '{paddleNumber}번 응찰자가 고객님보다 높은 부재자 응찰가를 제시했습니다',
                you_ve_won_lot: 'Lot {lotNumber} 낙찰받으셨습니다. 축하드립니다',
            },
            missives: {
                fair_warning_lot_about_to_close: '이번 Lot 곧 마무리하겠습니다',
                going_once_going_twice: '한번... 두번...',
                third_and_final_warning: '세번... 마무리합니다',
            },
            status: {
                remaining: '{total} Lot중에 {remaining}개 남았습니다',
            },
            thumbnail_scroller: {
                next: '다음 Lot 미리보기',
            },
        },
    },
};
